module.exports = __webpack_public_path__ + "img/组 46.0ffdfce2.png";